import * as React from 'react'
import { useState, useEffect } from 'react';
// ─────────────────────────────────────────────
// COMPONENT 3: LiveMetricsSection
// PLACEMENT: New <section> between #stats and #testimonials
// Usage: <LiveMetricsSection />
// ─────────────────────────────────────────────
const METRICS = [
  { value: "2.4s", label: "Avg. document processing time", delay: 0 },
  { value: "99.1%", label: "Automation accuracy rate", delay: 400 },
  { value: "18×", label: "Faster than manual workflows", delay: 800 },
];

function PulseCard({ value, label, delay, barHeights }) {
  return (
    <div className="rs-pulse-card">
      <div className="rs-pulse-live">
        <span className="rs-pulse-dot" style={{ animationDelay: delay + "ms" }} />
        LIVE
      </div>
      <div className="rs-pulse-val">{value}</div>
      <div className="rs-pulse-desc">{label}</div>
      <div className="rs-bar-row">
        {barHeights.map((h, i) => (
          <div
            key={i}
            className={`rs-bar ${h.active ? "rs-bar-active" : ""}`}
            style={{ height: h.height + "px" }}
          />
        ))}
      </div>
    </div>
  );
}

function randomBars() {
  return Array.from({ length: 12 }, () => ({
    height: 8 + Math.floor(Math.random() * 22),
    active: Math.random() > 0.35,
  }));
}

export function LiveMetricsSection() {
  const [bars, setBars] = useState([
    randomBars(),
    randomBars(),
    randomBars(),
  ]);

  useEffect(() => {
    const id = setInterval(() => {
      setBars([randomBars(), randomBars(), randomBars()]);
    }, 1800);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="live-metrics">
      <style>{`
        #live-metrics { position: relative; z-index: 3; padding: 120px 0; }
        .rs-pulse-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        .rs-pulse-card {
          background: rgba(14,22,35,0.9);
          border: 1px solid #1D3145;
          border-radius: 20px;
          padding: 28px 24px;
          position: relative;
          overflow: hidden;
        }
        .rs-pulse-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(73,214,255,0.6), transparent);
        }
        .rs-pulse-live {
          display: flex;
          align-items: center;
          gap: 8px;
          font-family: 'JetBrains Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.12em;
          color: #49D6FF;
          margin-bottom: 12px;
        }
        .rs-pulse-dot {
          width: 7px; height: 7px;
          border-radius: 50%;
          background: #49D6FF;
          display: inline-block;
          animation: rsPulseRing 2s infinite;
        }
        @keyframes rsPulseRing {
          0%   { box-shadow: 0 0 0 0 rgba(73,214,255,0.5); }
          70%  { box-shadow: 0 0 0 9px rgba(73,214,255,0); }
          100% { box-shadow: 0 0 0 0 rgba(73,214,255,0); }
        }
        .rs-pulse-val {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          font-size: 36px;
          color: #FFFFFF;
          margin-bottom: 6px;
        }
        .rs-pulse-desc { font-size: 14px; color: #A7B3C2; }
        .rs-bar-row { display: flex; gap: 3px; margin-top: 18px; align-items: flex-end; }
        .rs-bar {
          width: 6px;
          border-radius: 3px;
          background: rgba(73,214,255,0.15);
          transition: height 0.4s cubic-bezier(.16,1,.3,1), background 0.4s;
        }
        .rs-bar.rs-bar-active { background: #49D6FF; }
        @media (max-width: 760px) { .rs-pulse-grid { grid-template-columns: 1fr; } }
      `}</style>
      {/* <div className="container"> */}
        <div className="section-head reveal">
          <div className="eyebrow">Real-time performance</div>
          <h2>Systems running. Numbers moving.</h2>
          <p>Live metrics from deployed Readal automation pipelines across active clients.</p>
        </div>
        <div className="rs-pulse-grid">
          {METRICS.map((m, i) => (
            <PulseCard key={i} {...m} barHeights={bars[i]} />
          ))}
        </div>
      {/* </div> */}
    </section>
  );
}
